/* Apparitions douces au défilement. Ne s'active jamais si l'utilisateur
   a demandé moins d'animations ou si le navigateur est trop ancien :
   dans ces cas le contenu reste simplement visible. */
(function () {
  if (window.__ccMotion) return;
  window.__ccMotion = true;

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduit || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('cc-motion-ready');

  var observateur = new IntersectionObserver(
    function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        observateur.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
  );

  function observer() {
    document.querySelectorAll('.cc-reveal:not(.is-in)').forEach(function (el) {
      observateur.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observer);
  } else {
    observer();
  }
  document.addEventListener('shopify:section:load', observer);
})();
